let lenis = null;

export const setLenis = (l) => { lenis = l; };

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -120, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollTop = () => {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};

export const EASE = [0.22, 1, 0.36, 1];
